const decimalValue = (num, precision = 0) => {
  return parseFloat(parseFloat(num).toFixed(precision));
};
export default decimalValue;
